import { render, staticRenderFns } from "./policyInterpretation.vue?vue&type=template&id=73480820&scoped=true"
import script from "./policyInterpretation.vue?vue&type=script&lang=js"
export * from "./policyInterpretation.vue?vue&type=script&lang=js"
import style0 from "./policyInterpretation.vue?vue&type=style&index=0&id=73480820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73480820",
  null
  
)

export default component.exports